/* eslint-disable import/no-cycle */
import CryptoJS from 'crypto-js';
import axios from 'axios';
import generateVersionHash from '@utils/generateVersionHash';
import { attempt, createStoreFetcher } from '@/lib/http';
import { btoa, atob, showAlert } from '../../lib/helpers';
import { dataIntervalExport } from '../params';
import { postApi } from '../../lib/fetcher';
import api, { ROLE } from './constants';
import unmaskingData from '../../lib/utils/unmaskingData';

// RM = Inputer
const rm = {
  namespaced: true,

  state() {
    return {
      allMerchants: [],
      allMerchantsHistory: [],
      totalMerchants: 0,
      totalMerchantsHistory: 0,
      loading: false,
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      merchant: null,
      aggregator: null,
      merchantDocument: [],
      merchantHistory: null,
      merchantHistoryDocument: [],
      totalPage: 0,
      intervalExport: null,
      exportId: null,
      countDataExport: 0,

      idAggregator: null,
      requestData: null,
    };
  },

  mutations: {
    setMerchants(state, { payload }) {
      state.allMerchants = payload.data.list;
    },

    setMerchantsHistory(state, { payload }) {
      state.allMerchantsHistory = payload.data.list;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearMerchants(state) {
      state.allMerchants = [];
      state.totalMerchants = 0;
    },

    clearMerchantsHistory(state) {
      state.allMerchantsHistory = [];
      state.totalMerchantsHistory = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalMerchants(state, { payload }) {
      state.totalMerchants = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setTotalMerchantsHistory(state, { payload }) {
      state.totalMerchantsHistory = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setDetailMerchant(state, { payload }) {
      state.merchant = payload;
    },

    setDetailMerchantHistory(state, { payload }) {
      state.merchantHistory = payload;
    },

    setMerchantVariable(state, { variable, payload }) {
      state.merchant[variable] = payload;
    },

    setMerchantDocument(state, document) {
      state.merchantDocument.push(document);
    },
    setMerchantHistoryDocument(state, document) {
      state.merchantHistoryDocument.push(document);
    },

    setDetailAggregator(state, { payload }) {
      state.aggregator = payload;
    },

    setAggregatorVariable(state, { variable, payload }) {
      state.aggregator[variable] = payload;
    },

    setIntervalExport(state, payload) {
      state.intervalExport = payload;
    },

    setExportData(state, payload) {
      state.exportId = payload.export_id;
      state.countDataExport = payload.count_data;
    },

    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },

    setIdAggregator(state, payload) {
      state.idAggregator = payload;
    },

    clearErrorVariable(state, variable) {
      state.errors = { ...state.errors, [variable]: [] };
    },

    setCancelation(state, payload) {
      state.requestData = payload;
    },
  },

  actions: {
    async validate(ctx, { date, no_rekening }) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();
      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      const data = JSON.stringify({
        account_number: no_rekening,
        version: btoa(
          CryptoJS.SHA256(
            no_rekening +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/onboarding/rekening/validate-rekening`;

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      let returnData = false;

      if (responseData?.code == '200') {
        returnData = true;
      }
      return returnData;
    },

    async fetchMerchants(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      ctx.commit('clearMerchants');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        if (sortBy[0] == 'mid') {
          sort_by = `mid_static ${sort}`;
        } else {
          sort_by = `${sortBy[0]} ${sort}`;
        }
      } else {
        sort_by = `id ${sort}`;
      }

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/request_list/inputer/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData) {
        ctx.commit('setTotalMerchants', {
          payload: responseData,
        });
        ctx.commit('setMerchants', { payload: responseData });
      }
    },

    async fetchMerchantsHistory(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      ctx.commit('clearMerchantsHistory');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'DESC' : 'ASC';
      let sort_by = '';
      if (sortBy[0] != null) {
        if (sortBy[0] == 'mid') {
          sort_by = `mid_static ${sort}`;
        } else {
          sort_by = `${sortBy[0]} ${sort}`;
        }
      } else {
        sort_by = `id ${sort}`;
      }

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/request_list/inputer/history`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData) {
        ctx.commit('setTotalMerchantsHistory', {
          payload: responseData,
        });
        ctx.commit('setMerchantsHistory', { payload: responseData });
      }
    },

    async viewAggregator(ctx, { date, id, isPageUpdate }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const headers = unmaskingData(id, date, isPageUpdate);

      const urlApi = `/index.php?r=api/v1/request_list/inputer/view`;

      const responseData = await postApi(ctx, urlApi, data, headers ? { headers } : {});

      if (responseData?.code == '200') {
        ctx.commit('setDetailAggregator', {
          payload: responseData.data,
        });
      }
    },

    async viewMerchant(ctx, { id, date,  isPageUpdate }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const headers = unmaskingData(id, date, isPageUpdate);

      const urlApi = `/index.php?r=api/v1/request_list/inputer/view`;

      const responseData = await postApi(ctx, urlApi, data, headers ? { headers } : {});

      if (responseData?.code == '200') {
        ctx.commit('setDetailMerchant', {
          payload: responseData.data,
        });
      }
    },

    async viewMerchantHistory(ctx, { date, id }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const urlApi = `/index.php?r=api/v1/request_list/inputer/history-view`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        ctx.commit('setDetailMerchantHistory', {
          payload: responseData.data,
        });
      }
    },

    /**
     * Approves or rejects one submission as the inputer role.
     *
     * @param {Object} ctx - Vuex action context.
     * @param {Object} params - Action payload.
     * @param {string} params.date - Timestamp used by the version hash.
     * @param {string|number} params.id - Submission being decided.
     * @param {string} params.remark - Reason entered by the user.
     * @param {string} params.category - Route segment naming the decision.
     * @returns {Promise<Object|false>} The response envelope, or false when the
     *   decision was rejected.
     */
    async approve_reject(ctx, { date, id, remark, category }) {
      const http = createStoreFetcher(ctx);

      return attempt(async () => {
        const res = await http.post(api.decision(ROLE.INPUTER, category), {
          id,
          remark,
          version: generateVersionHash(id.toString() + remark.toString(), date),
        });

        showAlert(
          ctx,
          res.message || 'Update Success !',
          'mdi-check-circle',
          'green'
        );

        return res;
      }, false);
    },

    async updateRMMerchant(
      ctx,
      {
        date,
        merchant_id,
        daerah,
        daerahOwner,
        tempUniqueData,
        documents,
        remark,
        reason,
        endpoint,
        ipAddress,
        channelQr,
        merchantModel,
        qrTypeInterface,
        isNeedInterface,
        isQrTypeWithAPI,
        regionalMapping,
        mdr_file,
        is_mdr_custom,
        mdr_on_us_override = null,
        mdr_off_us_override = null,
      }
    ) {
      const dataObj = {
        channel_qr: channelQr || ctx.state.merchant.channel_qr,
        merchant_model: merchantModel || ctx.state.merchant.merchant_model_id,
        id: merchant_id,
        merchant_name: ctx.state.merchant.merchant_name,
        account_type: ctx.state.merchant.id_account_type,
        qr_type: ctx.state.merchant.id_qr_type,
        ktp_no:
          tempUniqueData.ktp_no == ctx.state.merchant.ktp_no
            ? ''
            : ctx.state.merchant.ktp_no,
        mobile_phone: ctx.state.merchant.mobile_phone,
        merchant_mobile_phone: ctx.state.merchant.merchant_mobile_phone,
        company_name: ctx.state.merchant.company_name,
        owner_name: ctx.state.merchant.owner_name,
        merchant_criteria: ctx.state.merchant.merchant_criteria_id,
        mcc: ctx.state.merchant.mcc_id,
        npwp_no:
          tempUniqueData.npwp_no == ctx.state.merchant.npwp_no
            ? ''
            : ctx.state.merchant.npwp_no,
        address: ctx.state.merchant.address,
        email:
          tempUniqueData.email == ctx.state.merchant.email
            ? ''
            : ctx.state.merchant.email,
        phone: ctx.state.merchant.phone,
        phone_area_code: ctx.state.merchant.phone_area_code,
        province_name: daerah.province_name,
        city_name: daerah.city_name,
        sub_district_name: daerah.sub_district_name,
        urban_name: daerah.urban_name,
        postal_code: daerah.postal_code,
        province_id: '',
        city_id: '',
        sub_district_id: '',
        urban_id: '',
        account_number:
          tempUniqueData.account_number == ctx.state.merchant.account_number
            ? ''
            : ctx.state.merchant.account_number,
        approver_1: ctx.state.merchant.approver_1_id,
        approver_2: ctx.state.merchant.approver_2_id,
        documents,
        merchant_type: ctx.state.merchant.merchant_type_id.toString(),
        nmid: ctx.state.merchant.nmid,
        mdr_on_us: mdr_on_us_override !== null ? mdr_on_us_override : ctx.state.merchant.mdr_on_us,
        mdr_off_us: mdr_off_us_override !== null ? mdr_off_us_override : ctx.state.merchant.mdr_off_us,
        remark,
        reason,
        mid: ctx.state.merchant.mid,
        tid: ctx.state.merchant.tid,
        endpoint,
        ip_address: ipAddress,
        owner_city_of_birth: ctx.state.merchant.owner_city_of_birth,
        owner_date_of_birth: ctx.state.merchant.owner_date_of_birth,
        owner_address: ctx.state.merchant.owner_address,
        owner_province_name: daerahOwner.province_name,
        owner_city_name: daerahOwner.city_name,
        owner_sub_district_name: daerahOwner.sub_district_name,
        owner_urban_name: daerahOwner.urban_name,
        owner_postal_code: daerahOwner.postal_code,
        account_holder_name: ctx.state.merchant.account_holder_name,
        bni_branch_office: ctx.state.merchant.bni_branch_office,
        merchant_est_since: ctx.state.merchant.merchant_est_since,
        merchant_email: ctx.state.merchant.merchant_email,
        is_mdr_custom: is_mdr_custom || false,
        version: btoa(
          CryptoJS.SHA256(
            merchant_id.toString() +
              ctx.state.merchant.merchant_name.toString() +
              ctx.state.merchant.owner_name.toString() +
              ctx.state.merchant.merchant_criteria_id.toString() +
              ctx.state.merchant.id_qr_type.toString() +
              daerah.postal_code.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      };

      if (regionalMapping) {
        dataObj.bcko = regionalMapping?.bcko || '';
        dataObj.cmer = regionalMapping?.cmer || '';
        dataObj.referral_code = regionalMapping?.referral_code || '';
      }

      if (isQrTypeWithAPI) {
        dataObj.is_need_interface = isNeedInterface !== undefined ? isNeedInterface : (ctx.state.merchant.is_need_interface || false);
      }

      const data = new FormData();
      
      Object.keys(dataObj).forEach((key) => {
        const value = dataObj[key];
        if (Array.isArray(value)) {
          value.forEach((item) => {
            data.append(`${key}[]`, item);
          });
        } else if (value !== null && value !== undefined) {
          data.append(key, value);
        }
      });

      if (isQrTypeWithAPI) {
        const qrInterface = qrTypeInterface || ctx.state.merchant.qr_type_interface || [];
        qrInterface.forEach((item) => {
          data.append('qr_type_interface[]', item);
        });
      }
      
      if (mdr_file) {
        data.append('mdr_file', mdr_file);
      }

      const http = createStoreFetcher(ctx);

      return attempt(async () => {
        const res = await http.post(api.REVISION_UPDATE, data);

        showAlert(
          ctx,
          res.message || 'Update Success !',
          'mdi-check-circle',
          'green'
        );

        return res;
      }, false);
    },

    async updateRMAggregator(
      ctx,
      {
        date,
        aggregator_id,
        daerah,
        tempUniqueData,
        qrType,
        accountType,
        remark,
        isStickerApi,
        regionalMapping,
      }
    ) {
      const data = {
        id: aggregator_id,
        aggre_pic_name: ctx.state.aggregator.aggre_pic_name,
        aggre_pic_ktp_no:
          tempUniqueData.aggre_pic_ktp_no ==
          ctx.state.aggregator.aggre_pic_ktp_no
            ? ''
            : ctx.state.aggregator.aggre_pic_ktp_no,
        aggre_pic_jabatan: ctx.state.aggregator.aggre_pic_jabatan,
        aggre_pic_mobile_phone: ctx.state.aggregator.aggre_pic_mobile_phone,
        aggre_pic_email:
          tempUniqueData.aggre_pic_email == ctx.state.aggregator.aggre_pic_email
            ? ''
            : ctx.state.aggregator.aggre_pic_email,
        merchant_name: ctx.state.aggregator.merchant_name,
        company_name: ctx.state.aggregator.company_name,
        owner_name: ctx.state.aggregator.owner_name,
        ktp_no:
          tempUniqueData.ktp_no == ctx.state.aggregator.ktp_no
            ? ''
            : ctx.state.aggregator.ktp_no,
        npwp_no:
          tempUniqueData.npwp_no == ctx.state.aggregator.npwp_no
            ? ''
            : ctx.state.aggregator.npwp_no,
        address: ctx.state.aggregator.address,
        email:
          tempUniqueData.email == ctx.state.aggregator.email
            ? ''
            : ctx.state.aggregator.email,
        merchant_criteria: ctx.state.aggregator.merchant_criteria_id,
        phone: ctx.state.aggregator.phone,
        phone_area_code: ctx.state.aggregator.phone_area_code,
        province_name: daerah.province_name,
        city_name: daerah.city_name,
        sub_district_name: daerah.sub_district_name,
        urban_name: daerah.urban_name,
        postal_code: daerah.postal_code,
        province_id: '',
        city_id: '',
        sub_district_id: '',
        urban_id: '',
        account_number:
          tempUniqueData.account_number == ctx.state.aggregator.account_number
            ? ''
            : ctx.state.aggregator.account_number,
        endpoint: ctx.state.aggregator.endpoint,
        ip_address: ctx.state.aggregator.ip_address,
        approver_1: ctx.state.aggregator.approver_1_id,
        approver_2: ctx.state.aggregator.approver_2_id,
        mcc: ctx.state.aggregator.mcc_id,
        account_type: accountType.toString(),
        merchant_type: ctx.state.aggregator.merchant_type_id.toString(),
        qr_type: qrType,
        nmid: ctx.state.aggregator.nmid,
        bcko: regionalMapping?.bcko || '',
        cmer: regionalMapping?.cmer || '',
        referral_code: regionalMapping?.referral_code || '',
        notif_sticker_status: isStickerApi
          ? ctx.state.aggregator.notif_sticker_status
          : '0',
        remark,
        version: generateVersionHash(
          aggregator_id.toString() +
            ctx.state.aggregator.merchant_name.toString() +
            ctx.state.aggregator.owner_name.toString() +
            ctx.state.aggregator.merchant_criteria_id.toString() +
            qrType.toString() +
            daerah.postal_code.toString(),
          date
        ),
      };

      const http = createStoreFetcher(ctx);

      return attempt(async () => {
        const res = await http.post(api.REVISION_UPDATE, data);

        showAlert(
          ctx,
          res.message || 'Update Success !',
          'mdi-check-circle',
          'green'
        );

        return res;
      }, false);
    },

    async exportList(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search, view }
    ) {
      if (ctx.rootState.isExport) {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export in progress !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        return;
      }
      ctx.commit('setLoading', true);
      ctx.commit('setIsExport', true, { root: true });
      ctx.commit('setStateVariable', {
        payload: 0,
        variable: 'countSameExport',
      });
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }
      const controller = (ctrl) => {
        switch (ctrl) {
          case 'rm-history':
            return 'export-history-rm-to-do-list';
          case 'rm':
            return 'export-rm-to-do-list';
          default:
            return 'export-rm-to-do-list';
        }
      };

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const failed = () => {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export Failed !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: false,
            absoluteBarText: '',
          },
          { root: true }
        );
        ctx.commit('setIsExport', false, { root: true });
      };

      const urlApi = `/index.php?r=api/v1/export/${controller(view)}/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        if (responseData.data.message != null) {
          showAlert(ctx, responseData.data.message, 'mdi-alert', 'red');
          ctx.commit('setIsExport', false, { root: true });
          return;
        }
        ctx.commit('setExportData', responseData.data);
        const interval = setInterval(() => {
          ctx.dispatch(
            'exportStatus',
            {
              date,
              exportId: ctx.state.exportId,
              countDataExport: ctx.state.countDataExport,
              controller: controller(view),
            },
            { root: true }
          );
        }, dataIntervalExport);
        ctx.commit('setIntervalExport', interval, { root: true });
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: true,
            absoluteBarText: 'Start to export data..',
          },
          { root: true }
        );
      } else {
        failed();
      }
    },
  },
};

export default rm;
